import { PopUpMessageContext, useAuth } from '@hb/react'
import { TotpMultiFactorGenerator, TotpMultiFactorInfo } from 'firebase/auth'
import { useCallback, useContext, useState } from 'react'
import { signInCallback } from '../../../backend/auth/signIn'

export const useAuthenticatorVerify = ({ factor }: { factor: TotpMultiFactorInfo }) => {
  const [code, setCode] = useState('')
  const [verifying, setVerifying] = useState(false)
  const [error, setError] = useState('')
  const resolver = useAuth(s => s.multiFactorResolver)
  const { showSuccess, showError, showInfo } = useContext(PopUpMessageContext)

  const handleVerify = useCallback(() => {
    if (!code) return
    if (!resolver) {
      setError('Error - No session found')
      return
    }
    setVerifying(true)
    const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(factor.uid, code)

    resolver
      .resolveSignIn(multiFactorAssertion)
      .then(credential => signInCallback(credential.user, showSuccess, showError, showInfo))
      .catch(e => {
        setError(e.message)
      })
      .finally(() => setVerifying(false))
  }, [code, factor, resolver, showSuccess, showError, showInfo])

  return {
    code,
    setCode,
    verifying,
    error,
    handleVerify,
  }
}
